import React from 'react';
import PropTypes from 'prop-types';

import {
  EXPERIENCE_POSITION,
  EXPERIENCE_EMPLOYER,
  CURRENT,
  DESCRIPTION,
} from '@zr/utilities/profileFields';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import PositionField from '@zr/components/Fields/Formik/PositionField';
import EmployerField from '@zr/components/Fields/Formik/EmployerField';
import CurrentlyWorkHereField from '@zr/components/Fields/Formik/CurrentlyWorkHereField';
import StartMonthField from '@zr/components/Fields/Formik/StartMonthField';
import StartYearField from '@zr/components/Fields/Formik/StartYearField';
import EndMonthField from '@zr/components/Fields/Formik/EndMonthField';
import EndYearField from '@zr/components/Fields/Formik/EndYearField';
import DescriptionField from '@zr/components/Fields/Formik/DescriptionField';

import {
  // these fields aren't profile jso fields, but are transformed into the profile date fields
  EXPERIENCE_START_YEAR,
  EXPERIENCE_START_MONTH,
  EXPERIENCE_END_YEAR,
  EXPERIENCE_END_MONTH,
} from '@zr/jobseeker-public/apps/profile-form/utilities/experienceFormUtilities';

export function ExperienceFields({
  formikProps, enableRichText,
}) {
  const { setValues, values } = formikProps;

  const handleCurrentChange = () => {
    // clear out end date values if current was changed
    // this also prevents submitting any previously filled values before changing current
    setValues({
      ...values,
      [EXPERIENCE_END_YEAR]: '',
      [EXPERIENCE_END_MONTH]: '',
    });
  };

  return (
    <>
      <PositionField
        name={EXPERIENCE_POSITION}
        formikProps={formikProps}
      />
      <EmployerField
        name={EXPERIENCE_EMPLOYER}
        formikProps={formikProps}
      />
      <CurrentlyWorkHereField
        name={CURRENT}
        onChange={handleCurrentChange}
        formikProps={formikProps}
      />
      <div className="date_fields">
        <StartYearField
          name={EXPERIENCE_START_YEAR}
          formikProps={formikProps}
        />
        {values[EXPERIENCE_START_YEAR] && (
          <StartMonthField
            name={EXPERIENCE_START_MONTH}
            formikProps={formikProps}
          />
        )}
      </div>
      {!values[CURRENT] && (
        <div className="date_fields">
          <EndYearField
            name={EXPERIENCE_END_YEAR}
            formikProps={formikProps}
          />
          {values[EXPERIENCE_END_YEAR] && (
            <EndMonthField
              name={EXPERIENCE_END_MONTH}
              formikProps={formikProps}
            />
          )}
        </div>
      )}
      <DescriptionField
        name={DESCRIPTION}
        formikProps={formikProps}
        enableRichText={enableRichText}
      />
    </>
  );
}

ExperienceFields.propTypes = {
  formikProps: formikPropTypes.isRequired,
  enableRichText: PropTypes.bool,
};

ExperienceFields.defaultProps = {
  enableRichText: false,
};

export default ExperienceFields;
